import { Link, useNavigate, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../../redux/auth/auth.duck";
import {
  ActionPopoverWrapper,
  NavbarWrapper,
  NotificationWrapper
} from "./styles";
import { Avatar, ImageCustom } from "..";
import {
  AppBar,
  Badge,
  Box,
  Button,
  CircularProgress,
  Divider,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  Modal,
  Popover,
  Popper,
  Stack,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
  useMediaQuery
} from "@mui/material";
import NotificationIcon from "../../assets/images/common/notification.png";
import ProfileIcon from "../../assets/images/common/icon_user_line_grey.svg";
import SettingIcon from "../../assets/images/common/icon_setting_line_grey.svg";
import SupportIcon from "../../assets/images/common/icon_question_line_grey.svg";
import LogoutIcon from "../../assets/images/common/icon_logout_line_red.svg";
import { useEffect, useMemo, useRef, useState } from "react";
import { toggleConfirmModal } from "../ConfirmModal/ConfirmModal";
import { ROUTE_PATH } from "../../common/constants/app.constant";
import { authTokens } from "../../services/services";
import { ITokenPayload, IUser } from "../../models/user";
import { useApi } from "../../hooks/useApi.hook";
import {
  IGroupNotification,
  INotification,
  INotificationCard
} from "../../models/notification";
import NotificationService from "../../services/api/notification.service";
import { TIME_FORMAT } from "../../config/constants";
import moment from "moment";
import "moment/locale/vi"; // Import Vietnamese locale
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import useNavigateSearch from "../NavigateSearch";
import { toggleMessage } from "../Toast/Toast";
import {
  eFireBaseComponent,
  EFireBaseType
} from "../../models/common/models.enum";
import DoneAllRoundedIcon from "@mui/icons-material/DoneAllRounded";
import CircleRoundedIcon from "@mui/icons-material/CircleRounded";
import variableStyles from "../../theme/variable-styles";
import Empty from "../../assets/images/sidebar/empty_notification.png";
import { theme } from "../../theme/theme";
import { sidebarItems } from "../../routes";
import { INavItem } from "../../models/app";
import {
  ArrowDropDownRounded,
  HtmlOutlined,
  SearchRounded
} from "@mui/icons-material";
import RoleService from "../../services/api/role.service";
import { IFeaturePermission } from "../../models/user/models.roles";
import { onMessage } from "firebase/messaging";
import { messaging } from "../../firebase";
import { useTranslation } from "react-i18next";
// ❌ bỏ import thừa
// import { t } from "i18next";
import ToggleSwitchLanguage from "../controls/Toggle/LanguageToggle";
import LanguageToggle from "../controls/Toggle/LanguageToggle";

type Props = {
  onMobileNavOpen: React.MouseEventHandler<HTMLButtonElement> | undefined;
};

const DashboardNavbar = ({ onMobileNavOpen }: Props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { t, i18n } = useTranslation();

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [userInfo, setUserInfo] = useState<ITokenPayload | null>(null);
  const [action, setAction] = useState<"ACCOUNT" | "NOTIFICATION" | null>(null);
  const [notifications, setNotifications] = useState<IGroupNotification[]>([]);
  const [currentPage, setCurrentPage] = useState<number | null>(null);
  const [totalNotification, setTotalNotification] = useState<number>(0);
  const [isUpdate, setIsUpdate] = useState(false);
  const [openRules, setOpenRules] = useState(false);
  const [activeNavCode, setActiveNavCode] = useState<string | null>("WORK");
  const [currentLocale, setCurrentLocale] = useState<string>("vi");
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  const channel = useMemo(
    () => new BroadcastChannel("reload-notification"),
    []
  );

  const role = useApi<IFeaturePermission[]>({ isFetch: true });

  const getNotifications = useApi<INotificationCard>({
    isFetch: true,
    isPaging: true
  });
  const updateNotification = useApi<INotificationCard>({});

  const counter = useSelector((state: any) => state.users.notification);

  useEffect(() => {
    setTotalNotification(totalNotification ?? 0);
    setIsUpdate(true);
  }, [counter]);

  useEffect(() => {
    if (getNotifications.data) {
      const list = getNotifications.data.groupNotification ?? [];

      if (currentPage === 1) {
        setNotifications(list);
      } else {
        setNotifications(prev => [...prev, ...list]);
      }

      setTotalNotification(getNotifications.data?.totalNotSeen);
    }
  }, [getNotifications.data]);

  const reloadCallback = (event: MessageEvent<any>) => {
    fetchData(true);
  };

  useEffect(() => {
    channel.addEventListener("message", reloadCallback);
    return () => {
      channel.removeEventListener("message", reloadCallback);
      channel.close();
    };
  }, [channel]);

  function fetchData(reset = false) {
    getNotifications.request(
      NotificationService.getPage({
        CurrentPage: reset ? 1 : (currentPage ?? 1),
        PageSize: 6
      })
    );

    if (reset) {
      setNotifications([]);
      setCurrentPage(1);
    }
  }

  const readllAll = async () => {
    await NotificationService.readAll();
    fetchData(true);
  };

  useEffect(() => {
    if (!isUpdate) {
      fetchData(false);
    }
  }, [currentPage]);

  useEffect(() => {
    async function getUserInfo() {
      const user = await authTokens.getUser();
      user && setUserInfo(user);
    }
    getUserInfo();
  }, []);

  // Sync moment locale with i18n language
  useEffect(() => {
    const currentLang = i18n.language.toUpperCase();
    const momentLocale = currentLang === "VI" ? "vi" : "en";
    moment.locale(momentLocale);
    setCurrentLocale(momentLocale);
  }, [i18n.language]);

  const onLogout = (event: any) => {
    event.preventDefault();
    const asyncFuncLogout: () => Promise<void> = async () => {
      await Promise.resolve(dispatch(logoutUser(navigate)));
    };

    toggleConfirmModal({
      title: t("Header.Logout.ConfirmTitle"),
      content: t("Header.Logout.ConfirmContent"),
      onSubmit: () => asyncFuncLogout(),
      submitText: t("Header.Logout.Button"),
      type: "warning-red"
    });
  };

  const menuDataProfile: { icon: string; text: string; link: string }[] = [
    {
      icon: ProfileIcon,
      text: t("Header.Profile.Account"),
      link: ROUTE_PATH.ACCOUNT
    },
    {
      icon: SupportIcon,
      text: t("Header.Profile.Support"),
      link: ROUTE_PATH.ADMIN_CHAT
    }
  ];

  const UserPopup = () => {
    return (
      <>
        <div className="profile-infor">
          <Avatar
            src={userInfo?.avatar}
            alt="Avatar-Image"
            width={"32px"}
            height={"32px"}
          />
          <div className="infor-detail">
            <p className="detail-name">{userInfo?.fullName}</p>
            <p className="detail-email">{userInfo?.email}</p>
          </div>
        </div>
        <Divider />
        <ul className="profile-actions">
          {menuDataProfile.map(action => (
            <li key={action.text}>
              <Link to={action.link}>
                <ImageCustom
                  src={action.icon}
                  alt="HEADER_ACTION"
                  width={"18px"}
                  height={"18px"}
                />
                <p>{action.text}</p>
              </Link>
            </li>
          ))}
        </ul>
        <Divider />
        <Button
          size="large"
          variant="text"
          className="profile-logout"
          onClick={onLogout}
        >
          <ImageCustom
            src={LogoutIcon}
            alt="HEADER_LOGOUT"
            width={"20px"}
            height={"20px"}
          />
          <p>{t("Header.Logout.Button")}</p>
        </Button>
      </>
    );
  };

  const NotificationPopup = () => {
    useEffect(() => {
      if (isUpdate) {
        setNotifications([]);
        fetchData();
        setIsUpdate(false);
      }
    }, []);

    const navigateSearch = useNavigateSearch();

    function checkPath(type: number, id?: string) {
      switch (type) {
        case EFireBaseType.AssignTask:
        case EFireBaseType.UpdateTask:
        case EFireBaseType.CommentTask:
        case EFireBaseType.ReplyCommentTask:
        case EFireBaseType.DeadlineTask:
          if (id) {
            navigateSearch(ROUTE_PATH.TASK, {
              id: id
            });
          }
          break;

        case EFireBaseType.RegisterTimeOff:
        case EFireBaseType.AprroveTimeOff:
          navigateSearch(ROUTE_PATH.TIMEOFF, {});
          break;

        case EFireBaseType.RegisterMeetingRoomSchedule:
        case EFireBaseType.AwaitCancelMeetingRoomSchedule:
        case EFireBaseType.AprroveMeetingRoomSchedule:
        case EFireBaseType.CancelMeetingRoomSchedule:
          navigateSearch(ROUTE_PATH.BOOKING, {});
          break;

        case EFireBaseType.ReleasedDocument:
          navigateSearch(ROUTE_PATH.DOCS, {});
          break;

        default:
          break;
      }
    }

    function handleCick(notification: INotification) {
      if (notification.viewed) {
        checkPath(
          notification.type,
          JSON.parse(notification.data).TaskId as string
        );
        setAnchorEl(null);
      } else {
        updateNotification.request(
          NotificationService.updateViewed({
            id: notification.id,
            Viewed: true
          }).then(response => {
            if (response.success) {
              if (totalNotification) {
                setTotalNotification(totalNotification - 1);
                setCurrentPage(null);
                setIsUpdate(true);
              }
              checkPath(
                notification.type,
                JSON.parse(notification.data).TaskId as string
              );
              setAnchorEl(null);
            } else {
              toggleMessage({
                type: "error",
                message: response?.error ?? t("Common.ErrorOccurred")
              });
            }
          })
        );
      }
    }

    return (
      <NotificationWrapper>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between"
          }}
        >
          <Typography className="title" variant="subtitle2" color={"#596970"}>
            {t("Header.Notifications.Title", {
              count: getNotifications.data?.totalNotSeen ?? 0
            })}
          </Typography>
          {notifications.length > 0 && (
            <Tooltip title={t("Header.Notifications.ReadAllTooltip")}>
              <Button
                onClick={() => {
                  toggleConfirmModal({
                    title: t("Header.Notifications.ReadAllConfirmTitle"),
                    content: t("Header.Notifications.ReadAllConfirmContent"),
                    onSubmit: async () => readllAll()
                  });
                }}
              >
                <DoneAllRoundedIcon className="check-svg" />
              </Button>
            </Tooltip>
          )}
        </div>
        <Divider />
        {notifications.length === 0 ? (
          <div style={{ justifyItems: "center" }}>
            <ImageCustom width="100px" height="100px" src={Empty} />
            <Typography variant="caption" color="#7E969F">
              {t("Header.Notifications.Empty")}
            </Typography>
          </div>
        ) : (
          notifications.map((item, idx) => (
            <Box key={idx} marginBottom="4px">
              <Box
                display="flex"
                marginBottom="8px"
                justifyContent="space-between"
                marginTop="4px"
              >
                <Typography
                  className="date-time"
                  variant="caption"
                  color={"#7E969F"}
                  fontWeight="600"
                >
                  {item.created}
                </Typography>
                <Typography
                  className="date-time"
                  variant="caption"
                  fontSize={10}
                  color="#7E969F"
                >
                  {moment(moment(item?.created, "DD/MM/YYYY")).fromNow()}
                </Typography>
              </Box>
              {item.notifications.map(notification => (
                <Box
                  key={notification.id}
                  display="flex"
                  padding="8px"
                  onClick={() => handleCick(notification)}
                  sx={{
                    backgroundColor: notification.viewed
                      ? "transparent"
                      : variableStyles.Info50
                  }}
                >
                  <Badge
                    invisible={true}
                    color="primary"
                    overlap="circular"
                    variant="dot"
                  >
                    <Avatar src={notification?.imageUrl} />
                  </Badge>
                  <Stack
                    direction="column"
                    spacing={0.2}
                    sx={{
                      justifyContent: "center",
                      alignItems: "flex-start",
                      marginLeft: "12px"
                    }}
                  >
                    <div
                      style={{ fontSize: "12px" }}
                      dangerouslySetInnerHTML={{
                        __html: notification.title
                      }}
                    />
                    <Box
                      display="flex"
                      justifyItems="space-between"
                      alignItems="center"
                      width="100%"
                      gap="8px"
                    >
                      {!notification.viewed && (
                        <CircleRoundedIcon
                          sx={{
                            fontSize: 8,
                            color: variableStyles.blueSecondary500
                          }}
                        />
                      )}
                      <Typography
                        variant="caption"
                        fontSize={12}
                        color="#7E969F"
                        flexGrow={1}
                      >
                        {moment(notification.created).format(TIME_FORMAT)}
                      </Typography>
                      <Box />
                      <Typography
                        variant="caption"
                        fontSize={"11px"}
                        color="#7E969F"
                      >
                        {eFireBaseComponent(notification.type).text}
                      </Typography>
                      <ImageCustom
                        width="20px"
                        height="20px"
                        src={eFireBaseComponent(notification.type).icon}
                      />
                    </Box>
                  </Stack>
                </Box>
              ))}
            </Box>
          ))
        )}
        {getNotifications.pagging?.totalCount! > 6 &&
          currentPage !== getNotifications.pagging?.totalPages && (
            <Button
              size="small"
              variant="text"
              color="info"
              onClick={() => {
                setCurrentPage((currentPage ?? 1) + 1);
              }}
              style={{ textAlign: "center", width: "100%" }}
              endIcon={
                getNotifications.loading ? undefined : (
                  <KeyboardArrowDownRoundedIcon />
                )
              }
            >
              {getNotifications.loading ? (
                <CircularProgress />
              ) : (
                <Typography variant="subtitle2" fontSize={12}>
                  {t("Header.Notifications.LoadMore")}
                </Typography>
              )}
            </Button>
          )}
      </NotificationWrapper>
    );
  };

  const sidebarData = sidebarItems(role.data);
  const [menuAnchorEl, setMenuAnchorEl] = useState<{
    left: any;
    sub?: INavItem[];
  } | null>(null);
  useEffect(() => {
    if (userInfo) {
      role.request(RoleService.getFeaturePemissionByUserId(userInfo.userId));
    }
  }, [userInfo]);

  const handleClose = () => {
    setMenuAnchorEl(null);
  };

  const buttonRef = useRef<(HTMLButtonElement | null)[]>([]);

  return (
    <div>
      <ActionPopoverWrapper
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
      >
        {action === "ACCOUNT" ? <UserPopup /> : <NotificationPopup />}
      </ActionPopoverWrapper>

      <AppBar
        sx={{
          backgroundColor: "#FFFFFF",
          position: "relative",
          zIndex: 1,
          boxShadow: "none",
          border: "1px solid #EDEDED",
          borderRadius: "0 0 0 8px"
        }}
      >
        <Toolbar
          sx={{
            "@media (min-width:1280px) and (max-width:1365px)": {
              paddingLeft: "16px",
              paddingRight: "16px"
            }
          }}
        >
          <Box
            className="nav-menu"
            sx={{
              display: "flex",
              flexGrow: 1,
              gap: "10px"
              // marginLeft: "20px"
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "10px",
                padding: "5px 0",
                borderRadius: "8px"
              }}
            >
              {sidebarData.map((nav, i) => {
                const isActive = activeNavCode === nav.code;

                return (
                  <Tooltip
                    title={t(nav.title) || ""}
                    arrow
                    placement="bottom"
                    slotProps={{
                      tooltip: {
                        sx: {
                          backgroundColor: variableStyles.MainColor,
                          fontSize: "12px",
                          fontWeight: 500,
                          color: "white"
                        }
                      },
                      arrow: {
                        sx: {
                          color: variableStyles.MainColor
                        }
                      }
                    }}
                  >
                    <Button
                      disableRipple
                      ref={el => (buttonRef.current[i] = el)}
                      key={nav.code}
                      variant="contained"
                      size="small"
                      className={isActive ? "active" : ""}
                      sx={{
                        minWidth: "40px",
                        padding: "10px",
                        height: "40px",
                        backgroundColor: isActive
                          ? "#05224E !important"
                          : "transparent !important",
                        boxShadow: "none",
                        color: "white",
                        cursor: "pointer",
                        borderRadius: "50%",
                        transition: "all 0.3s ease-in-out",
                        "& img": {
                          filter: isActive ? "brightness(0) invert(1)" : "",
                          transition: "all 0.3s ease-in-out"
                        },
                        "&:hover": {
                          backgroundColor: "#05224E !important",
                          "& img": {
                            filter: "brightness(0) invert(1)"
                          }
                        },
                        // ⭐ THÊM MEDIA QUERY
                        "@media (min-width:1280px) and (max-width:1365px)": {
                          minWidth: "36px",
                          height: "36px",
                          padding: "8px"
                        }
                      }}
                      // endIcon={
                      //   nav.children && nav.children.length > 1 ? (
                      //     <KeyboardArrowDownRoundedIcon />
                      //   ) : undefined
                      // }
                      onMouseEnter={e => {
                        const rect = buttonRef.current[i]?.offsetLeft;
                        if (nav.children && nav.children?.length > 1) {
                          setMenuAnchorEl({
                            left: rect,
                            sub: nav.children
                          });
                        }
                      }}
                      onClick={() => {
                        setActiveNavCode(nav.code ?? null);
                        if (nav.children && nav.children.length > 0) {
                          if (nav.code == "DRIVE") {
                            nav.children[0].href &&
                              window.open(nav.children[0].href, "_blank");
                          } else {
                            navigate(
                              nav.children[0].href ?? ROUTE_PATH.NOTFOUND
                            );
                          }
                        }
                      }}
                    >
                      <ImageCustom
                        src={nav.icon?.active}
                        alt="Icon-Navbar"
                        width={"100%"}
                        height={"100%"}
                      />
                    </Button>
                  </Tooltip>
                );
              })}
            </div>
          </Box>

          <div
            className="header-action"
            style={{ display: "flex", gap: "12px", alignItems: "center" }}
          >
            <div className="actice-group">
              <span
                style={{
                  color: "#05224E",
                  fontSize: "14px",
                  fontWeight: "bold",
                  margin: "0 10px"
                }}
              >
                {moment()
                  .locale(currentLocale)
                  .format("dddd, DD/MM/YYYY")
                  .replace(/^\w/, c => c.toUpperCase())}
              </span>

              <Button
                size="large"
                variant="text"
                className="action-button"
                onClick={event => {
                  setAction("NOTIFICATION");
                  setAnchorEl(event.currentTarget);
                }}
              >
                <Badge
                  color="error"
                  badgeContent={totalNotification}
                  max={99}
                  sx={{
                    "& .MuiBadge-standard": {
                      fontSize: matches ? "10px" : "11px"
                    },
                    lineHeight: "24px"
                  }}
                >
                  <ImageCustom
                    src={NotificationIcon}
                    alt="Notification-Icon"
                    width={"40px"}
                    height={"40px"}
                  />
                </Badge>
              </Button>
            </div>
            <Divider
              sx={{
                color: "#000000",
                height: "24px",
                margin: "auto 0",
                opacity: 0.5
              }}
              orientation="vertical"
            />

            <LanguageToggle />

            <Divider
              sx={{
                color: "#000000",
                height: "24px",
                margin: "auto 0",
                opacity: 0.5
              }}
              orientation="vertical"
            />
            <Tooltip
              title={userInfo?.fullName}
              arrow
              placement="bottom-start"
              slotProps={{
                tooltip: {
                  sx: {
                    backgroundColor: variableStyles.MainColor,
                    fontSize: "12px",
                    fontWeight: 500,
                    color: "white",
                    boxShadow: "0 0 5px #ffffff"
                  }
                },
                arrow: {
                  sx: {
                    color: "#05224E"
                  }
                }
              }}
            >
              <Button
                size="large"
                variant="text"
                className="action-profile"
                onClick={event => {
                  setAction("ACCOUNT");
                  setAnchorEl(event.currentTarget);
                }}
              >
                <Avatar
                  src={userInfo?.avatar}
                  alt="Avatar-Image"
                  width={"32px"}
                  height={"32px"}
                />
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column"
                  }}
                >
                  {/* {!matches && (
                  <Typography color="#000000" marginLeft="12px" fontSize={13}>
                    {t("Common.Hello")},{" "}
                    <span style={{ fontWeight: "bold" }}>
                      {userInfo?.fullName}
                    </span>
                  </Typography>
                )} */}
                </div>
              </Button>
            </Tooltip>
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
};

DashboardNavbar.propTypes = {
  onMobileNavOpen: PropTypes.func
};

export default DashboardNavbar;
